export default function getCountyNameFromJson(json,geo_id) {
const feature = json?.features?.find(
    (f) => f?.properties?.geoid === geo_id
  );
  return feature?.properties?.NAME ?? null;
 
}
